import { controls,grouped } from "../controls";
const instdet = {
label: "Institutional Details",
pageLabel: "Institutional Details",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Ho Address",uid: "ho_address"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Full Name"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "full_name",width:"col-sm-4",maxlength:100}),
...controls.magicDateLabel({ tab: "filter", label: "Date of Est.",target: "doi"}),
...controls.magicDate({ tab: "filter", name: "doi", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "TAN"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "tan",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "GSTIN"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "gstin",maxlength:15}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Industry Type Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "industry_type_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Full Name",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "full_name",isRequired:true,width:"col-sm-4",maxlength:100}),
...controls.magicDateLabel({ tab: "general", label: "Date of Est.",target: "doi",star:true}),
...controls.magicDate({ tab: "general", name: "doi", dateType: "ontype",isRequired:true }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "TAN",star:true}),
...controls.tanNumber({ tab: "general",  placeHolder: "", name: "tan",isRequired:true,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "GSTIN",star:true}),
...controls.gstinNumber({ tab: "general",  placeHolder: "", name: "gstin",isRequired:true,maxlength:15}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Industry Type",star:false}),
...controls.oc({ tab: "general", c: "IndustryType", placeHolder: "Industry Type Code", name: "industry_type_code", isRequired:false,fastpath:"industry_types",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "industry_type_display"}),
...controls.displayText({ tab: "ho_address", label: "Line 1",star:false}),
...controls.text({ tab: "ho_address",  placeHolder: "", name: "ho_address.line_1",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "ho_address", label: "Line 2",star:false}),
...controls.text({ tab: "ho_address",  placeHolder: "", name: "ho_address.line_2",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "ho_address", label: "Line 3",star:false}),
...controls.text({ tab: "ho_address",  placeHolder: "", name: "ho_address.line_3",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "ho_address", label: "Village",star:true}),
...controls.oc({ tab: "ho_address", c: "Village", placeHolder: "Village Code", name: "ho_address.village_code", isRequired:true,fastpath:"villages"}),
...controls.showData({ tab: "ho_address", displaytype: "capital", data: "ho_address.village_display"}),
...controls.displayText({ tab: "ho_address", label: "Taluka",star:true}),
...controls.oc({ tab: "ho_address", c: "Taluka", placeHolder: "Taluka Code", name: "ho_address.taluka_code", isRequired:true,fastpath:"talukas"}),
...controls.showData({ tab: "ho_address", displaytype: "capital", data: "ho_address.taluka_display"}),
...controls.displayText({ tab: "ho_address", label: "District",star:true}),
...controls.oc({ tab: "ho_address", c: "District", placeHolder: "District Code", name: "ho_address.district_code", isRequired:true,fastpath:"districts"}),
...controls.showData({ tab: "ho_address", displaytype: "capital", data: "ho_address.district_display"}),
...controls.displayText({ tab: "ho_address", label: "State",star:true}),
...controls.oc({ tab: "ho_address", c: "State", placeHolder: "State Code", name: "ho_address.state_code", isRequired:true,fastpath:"states"}),
...controls.showData({ tab: "ho_address", displaytype: "capital", data: "ho_address.state_display"}),
...controls.displayText({ tab: "ho_address", label: "Country",star:true}),
...controls.oc({ tab: "ho_address", c: "Country", placeHolder: "Country Code", name: "ho_address.country_code", isRequired:true,fastpath:"countries"}),
...controls.showData({ tab: "ho_address", displaytype: "capital", data: "ho_address.country_display"}),
...controls.displayText({ tab: "ho_address", label: "Pincode",star:false}),
...controls.text({ tab: "ho_address",  placeHolder: "", name: "ho_address.pincode",isRequired:false,maxlength:6}),
...controls.displayText({ tab: "ho_address", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Institutional Details",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Full Name",accessor: "full_name",},
{Header: "Date of Est.",accessor: "doi",type:'date'},
{Header: "TAN",accessor: "tan",},
{Header: "GSTIN",accessor: "gstin",},
{Header: "Industry Type Id",accessor: "industry_type_id",},
]}};
export default instdet;